import { Box, Tooltip, TooltipProps, Typography } from '@mui/material'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export interface IConfirmPopupProps extends Omit<TooltipProps, 'title'> {
  children: any
  open?: boolean
  onClose?: () => void
  onConfirm?: () => void
  onCancel?: () => void
}

export const ConfirmPopup: FC<IConfirmPopupProps> = ({
  children,
  onClose,
  open,
  onConfirm,
  onCancel,
  ...props
}) => {
  const { t, i18n } = useTranslation()
  return (
    <TooltipStyles>
      <Tooltip
        componentsProps={{
          tooltip: {
            sx: {
              margin: 0,
              padding: '1rem 2rem',
              bgcolor: 'common.white',
              color: 'common.black',
              borderRadius: 0,
            },
          },
        }}
        onClose={onClose}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={
          <Box display='flex' flexDirection='column' alignItems='center'>
            <Typography variant='body1'>{t('popup_are_you_sure')}</Typography>
            <Box display='flex' flexDirection='row' gap='2rem'>
              <Typography
                sx={{ cursor: 'pointer' }}
                variant='body2'
                onClick={onConfirm}
              >
                {t('yes')}
              </Typography>
              <Typography
                sx={{ cursor: 'pointer' }}
                variant='body2'
                onClick={onCancel}
              >
                {t('no')}
              </Typography>
            </Box>
          </Box>
        }
        {...props}
      >
        {children}
      </Tooltip>
    </TooltipStyles>
  )
}

const TooltipStyles = styled.div``
